/**
 * Antifraud frontend API
 * Antifraud frontend API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum SubjectCategoryCreationReason {
    AF_RULE = 'AF_RULE',
    COMPROMISED_CARD = 'COMPROMISED_CARD',
    DETAILS_ONLINE = 'DETAILS_ONLINE',
    ENTERING_ON_FAKE_WEBSITE = 'ENTERING_ON_FAKE_WEBSITE',
    LOST_CARD = 'LOST_CARD',
    MOBILE_OPERATOR_FRAUD_DETECTION = 'MOBILE_OPERATOR_FRAUD_DETECTION',
    MULTIPLE_LOAN_APPLICATIONS = 'MULTIPLE_LOAN_APPLICATIONS',
    OTHER = 'OTHER',
    RELATIVE_REPORTED = 'RELATIVE_REPORTED',
    SUSPICIOUS_CALL = 'SUSPICIOUS_CALL',
    SUSPICIOUS_SMS = 'SUSPICIOUS_SMS',
    UNSECURED_WI_FI = 'UNSECURED_WI_FI'
}

